<template>
<b-row>
  <b-col>
    <b-row>
      <b-col>
        <button v-if="prevRoute.name !== 'EXSBRefundList'" @click="$router.go(-1)" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.goBack')}}</button>
        <router-link v-else :to="{ name: 'EXSBRefundList' }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="isLoading">
          <Loader />
        </div>
        <div v-else>
          <b-card>
            <b-row>
            <b-col cols="6">
              <p v-if="retrieved.idClient">{{ $t('views.exsbrefund.list.contractor') }}: <b>{{retrieved.idClient.firmname1 || ''}}</b></p>
              <p v-if="retrieved.idAgreement">{{ $t('views.exsbrefund.list.agreement') }}: <b>{{retrieved.idAgreement.agreementNumber || ''}}</b></p>
              <p v-if="retrieved.idEXSBInvoice">{{ $t('views.exsbrefund.list.invoice') }}: <b>{{retrieved.idEXSBInvoice.number || ''}}</b></p>
              <p v-if="retrieved.idBank">{{ $t('views.exsbrefund.list.bank') }}: <b>{{retrieved.idBank.title || ''}}</b></p>
            </b-col>
            <b-col cols="6">
              <p v-if="retrieved.value">{{ $t('views.exsbrefund.list.value') }}: <b>{{retrieved.value}}</b></p>
              <p v-if="retrieved.valueProvision">{{ $t('views.exsbrefund.form.valueProvision') }}: <b>{{retrieved.valueProvision}}</b></p>
              <p v-if="retrieved.paymentDate">{{ $t('views.exsbrefund.form.paymentDate') }}: <b>{{$moment(retrieved.paymentDate).format('YYYY-MM-DD')}}</b></p>
              <p v-if="retrieved.paymentsType">{{ $t('views.exsbrefund.form.paymentsType') }}: <b>{{paymentWay}}</b></p>
              <p v-if="retrieved.fromAccount">{{ $t('views.exsbrefund.form.fromAccount') }}: <b>{{retrieved.fromAccount}}</b></p>
              <p v-if="retrieved.description">{{ $t('views.exsbrefund.form.description') }}: <b>{{retrieved.description}}</b></p>
            </b-col>
            </b-row>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-col>
</b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'Show',
  components: {
    Loader
  },
  data () {
    return {
      prevRoute: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    paymentWay () {
      for (let i in this.paymentsTypeOptions) {
        if (this.paymentsTypeOptions[i].value === this.retrieved.paymentsType) {
          return this.$t(this.paymentsTypeOptions[i].text)
        }
      }
      return ''
    },
    ...mapGetters({
      retrieved: 'exsbrefund/show/retrieved',
      isLoading: 'exsbrefund/show/isLoading',
      paymentsTypeOptions: 'exsbrefund/list/paymentsTypeOptions'
    })
  },
  created () {
    this.retrieve(this.id)
  },
  methods: {
    ...mapActions({
      retrieve: 'exsbrefund/show/retrieve'
    })
  }
}
</script>

<style scoped>

</style>
